module.exports = __webpack_public_path__ + "static/media/bg4.2ed67a6e.webp";